
import CodeSnippet from '@/components/molecules/code-snippet/code-snippet';
import FButton from '@/components/atoms/buttons/h-button';
import FCheckbox from '@/components/atoms/forms/h-checkbox';
import FSelect from '@/components/atoms/forms/h-select';
import FTextField from '@/components/atoms/forms/h-text-field';
import propsTable from '@/components/organisms/content/props-table';
import TestingPropCodeSnippet from '@/components/organisms/content/testing-prop-code-snippet';
import TrackingCodeSnippet from '@/components/organisms/content/tracking-code-snippet';
import WidgetCodeSnippet from '@/components/organisms/content/widget-code-snippet';

import formValidation from '@/mixins/validation';

export default {
  name: 'PageWidgetLibrary',

  components: {
    CodeSnippet,
    FButton,
    FCheckbox,
    FSelect,
    FTextField,
    propsTable,
    TestingPropCodeSnippet,
    TrackingCodeSnippet,
    WidgetCodeSnippet,
  },

  mixins: [formValidation],

  layout: 'basic-without-footer',

  data() {
    return {
      displayCodeExample: false,
      form: {
        locale: 'de',
        propertyPrice: null,
        downPayment: null,
        postcode: null,
        commissionValue: null,
        financialType: null,
        payoutDate: null,
        repayment: null,
        propertyValue: null,
        remainingLoanAmount: null,
        trackingID: null,
        testingMode: true,
        skipCalculation: false,
      },
      localeOptions: [
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Deutsch',
          value: 'de',
        },
      ],
      financialTypeOptions: [
        {
          text: this.$t('financial-type-purchase'),
          value: 'purchase',
        },
        {
          text: this.$t('financial-type-refi'),
          value: 'refinancing',
        },
      ],
      rules: {
        isNumeric: (value) =>
          this.isNumeric(value) || 'Please enter a numeric value only',
        isDecimal: (value) =>
          this.isDecimal(value) || 'Please enter a valid value',
        commissionBetween: (value, min = 0, max = 3.57) =>
          this.isValueBetween(value, min, max) ||
          this.$t('commission-error', {
            minValue: min,
            maxValue: max,
          }),
        repaymentBetween: (value, min = 1, max = 5) =>
          this.isValueBetween(value, min, max) ||
          this.$t('repayment-error', {
            minValue: min,
            maxValue: max,
          }),
        isValidDate: (date) =>
          this.isPayoutDateValid(date) || this.$t('date-is-invalid'),
      },
    };
  },

  head() {
    return {
      title: this.$t('pageTitle'),
      script: [
        {
          hid: 'hyp-widget',
          src: this.$config.NUXT_ENV_WIDGET_APP,
          defer: true,
        },
      ],
    };
  },

  computed: {
    widgetPropsExample() {
      let props = '';

      if (this.form.locale) {
        props += `\n  locale="${this.form.locale}"`;
      }

      if (this.form.propertyPrice) {
        props += `\n  property-price="${this.form.propertyPrice}"`;
      }

      if (this.form.commissionValue) {
        props += `\n  commission="${this.form.commissionValue}"`;
      }

      if (this.form.downPayment) {
        props += `\n  down-payment="${this.form.downPayment}"`;
      }

      if (this.form.financialType) {
        props += `\n  financial-type="${this.form.financialType}"`;
      }

      if (this.form.postcode) {
        props += `\n  postcode="${this.form.postcode}"`;
      }

      if (this.form.payoutDate) {
        props += `\n  payout-date="${this.form.payoutDate}"`;
      }

      if (this.form.repayment) {
        props += `\n  repayment="${this.form.repayment}"`;
      }

      if (this.form.propertyValue) {
        props += `\n  property-value="${this.form.propertyValue}"`;
      }

      if (this.form.remainingLoanAmount) {
        props += `\n  remaining-loan-amount="${this.form.remainingLoanAmount}"`;
      }

      if (this.form.trackingID) {
        props += `\n  tracking-id="${this.form.trackingID}"`;
      }

      if (this.form.skipCalculation) {
        props += `\n  skip-calculation`;
      }

      if (this.form.testingMode) {
        props += `\n  testing`;
      }

      return `<hypofriend-calculator${props}${
        props ? '\n' : ''
      }>\n</hypofriend-calculator>`;
    },

    hashOfFormObject() {
      const tempFormObject = { ...this.form };
      delete tempFormObject.locale;

      return this.createHash(JSON.stringify(tempFormObject));
    },
  },

  mounted() {
    this.form.locale = this.$i18n.locale;
  },

  methods: {
    hasList(object) {
      return typeof object === 'object';
    },

    hasComponent(item) {
      return item in this.$options.components;
    },

    createHash(string) {
      return string.split('').reduce(function (a, b) {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
      }, 0);
    },

    scrollTo(section) {
      this.$vuetify.goTo(section, {
        offset: 12,
        easing: 'easeInOutCubic',
      });
    },

    viewCodeExample(visibility) {
      this.displayCodeExample = visibility;

      if (this.displayCodeExample) {
        setTimeout(() => this.scrollTo('#display-code-example'), 100);
      }
    },
  },
};
